import { useLocation } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import {
  fetchPatientsAsync,
  setPatientSearchQueryValue,
} from '../patients/patientsSlice'
import SelectableSearch from './selectedtableseacrh'
import { opdRoute, opdSearchOptions } from './constant'
import DropdownMenu from '../../components/DropdownMenu/DropdownMenu'
import { toast } from 'react-toastify'
import { selectedVisitId, setSelectedVisitId } from '../opd/OpdPatientSlice'
import { deleteVisitId, archiveVisitId } from '../../services/OPDService'
import { exportExcel } from '../../utils/hooks/Utils'
import { dropDownMenuKeys, noDataMessage } from '../../components/constants'
import './opdVisit.scss'
import {
  selectOpdVisitStatus,
  setOpdVisitStatus,
} from '../appointments/appointmentsSlice'
const OPDSearch = ({
  onSearch,
  onCreateVisit,
  thopId,
  rowData,
  setCount,
  count,
}: {
  onSearch?: (query: string, param: string) => void
  onCreateVisit: () => void
  thopId: any
  rowData?: any[]
  patientList?: any[]
  setCount: (e: number) => void
  count: number
}) => {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const opdStatus = useAppSelector(selectOpdVisitStatus)
  const handleSearch = (query: string, param: string) => {
    let q = ''
    switch (query) {
      case 'ID':
        q = 'identifier'
        break
    }
    dispatch(setPatientSearchQueryValue({ query: q, value: param }))
    dispatch(fetchPatientsAsync())
    onSearch?.(q, param)
  }
  const deleteVisit = async () => {
    const response = await deleteVisitId(selectVisitId)
    if (response?.success) {
      toast?.success(response?.message)
      dispatch(setSelectedVisitId(null))
      dispatch(fetchPatientsAsync())
      setCount(count + 1)
    } else {
      toast?.error(response?.message)
      dispatch(setSelectedVisitId(null))
      dispatch(fetchPatientsAsync())
    }
  }
  const archiveVisit = async () => {
    const response = await archiveVisitId(selectVisitId)
    if (response?.success) {
      toast.success(response?.message)
      dispatch(setSelectedVisitId(null))
      setCount(count + 1)
    } else {
      toast.error(response?.message)
      dispatch(setSelectedVisitId(null))
    }
  }
  const handleExport = () => {
    if (rowData && rowData?.length > 0) {
      exportExcel(rowData)
    } else {
      toast?.error(noDataMessage)
    }
  }
  const handleSelect = (e: any) => {
    const key = e?.[0]
    switch (key) {
      case dropDownMenuKeys?.delete:
        deleteVisit()
        break
      case dropDownMenuKeys?.archive:
        archiveVisit()
        break
      case dropDownMenuKeys?.export:
        handleExport()
        break
      case dropDownMenuKeys?.active:
        dispatch(setOpdVisitStatus(dropDownMenuKeys?.active))
        break
      case dropDownMenuKeys?.inActive:
        dispatch(setOpdVisitStatus(dropDownMenuKeys?.inActive))
        break
      default:
        // no-op
        break
    }
  }
  const selectVisitId = useAppSelector(selectedVisitId)

  return (
    <div className='patient-filter-btn opd-search-padding'>
      <div className='opd-search-container'>
        <DropdownMenu
          onSelect={handleSelect}
          filterOptions={[
            {
              label: dropDownMenuKeys?.activeKey,
              value: dropDownMenuKeys?.active,
              active: opdStatus === dropDownMenuKeys?.active,
            },
            {
              label: dropDownMenuKeys?.inActiveKey,
              value: dropDownMenuKeys?.inActive,
              active: opdStatus === dropDownMenuKeys?.inActive,
            },
          ]}
          actionOptions={[
            {
              label: dropDownMenuKeys?.exportKey,
              value: dropDownMenuKeys?.export,
            },
            {
              label: dropDownMenuKeys?.deleteKey,
              value: dropDownMenuKeys?.delete,
              disabled: !selectVisitId,
            },
            {
              label: dropDownMenuKeys?.archiveKey,
              value: dropDownMenuKeys?.archive,
              disabled: !selectVisitId,
            },
          ]}
          selectedId={selectVisitId ? true : false}
          filterApply={opdStatus === dropDownMenuKeys?.inActive}
        />
      </div>
      <div className='patient-search opd-search-padding'>
        <SelectableSearch
          items={opdSearchOptions}
          onSearch={handleSearch}
          thopId={thopId}
        />
      </div>
      {location?.pathname === opdRoute && (
        <div>
          <button
            className='btn btn-primaryBtn visit-margin-content'
            onClick={onCreateVisit}
          >
            Create Visit
          </button>
        </div>
      )}
    </div>
  )
}

export default OPDSearch
